import { FolderKanban } from 'lucide-react';

import { page, type DeclarationModule } from '@/app/moduleRegistry';

/**
 * Declaration du module Workflows : projets, etapes, modeles, suivi partage.
 *
 * `id` correspond a `WorkflowsModule.CleModule` cote back.
 *
 * La page publique de suivi (`/suivi/:jeton`) N'EST PAS declaree ici : elle vit
 * hors de la coquille authentifiee et hors du registre, puisqu'elle doit
 * fonctionner sans session, sans entreprise resolue et sans savoir si le module
 * est actif pour l'emetteur — le back seul en decide, a partir du jeton (§6).
 */
export const moduleWorkflows: DeclarationModule = {
  id: 'workflows',
  libelle: 'Projets',
  icone: FolderKanban,
  ordre: 30,

  routes: [
    {
      chemin: 'projets',
      estAccueil: true,

      // Libelle EXPLICITE, sinon la barre laterale perd cette entree : des qu'un
      // module envoie une route vers les parametres, seules les routes nommees
      // apparaissent encore dans la navigation principale.
      libelleNav: 'Projets',
      composant: page(() => import('./pages/ListeProjetsPage')),
    },
    {
      chemin: 'projets/:projetId',
      composant: page(() => import('./pages/FicheProjetPage')),
    },
    {
      chemin: 'modeles-workflow',

      // ROUTE LIVREE SANS CHEMIN POUR Y ARRIVER. Elle n'etait citee nulle part
      // dans la navigation : seule une URL tapee a la main y menait, alors que la
      // fiche projet invite a « partir d'un modele ». Dans les parametres, comme
      // les autres ecrans qu'on regle une fois puis qu'on oublie.
      libelleNav: 'Modeles de workflow',
      dansParametres: true,
      composant: page(() => import('./pages/ModelesPage')),
    },
  ],
};
